module.exports = __webpack_public_path__ + "img/review-13.e6d3ce97.jpg";